import { SectionProps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { PolicyAdjustmentResponse } from '../../../../domain'
import { useCoverLevelOption } from '../../../../hooks/coverOption'
import { usePolicy } from '../../../product/policy/PolicyProvider'
import { useProduct } from '../../../product/ProductProvider'
import { MonthlyPremiumSection } from './components/MonthlyPremiumSection'
import { SinglePaymentPremiumSection } from './components/SinglePaymentPremiumSection'

export interface ProrataPremiumSectionProps extends SectionProps {
  adjustment: PolicyAdjustmentResponse
}

export const ProrataPremiumSection: FunctionComponent<ProrataPremiumSectionProps> = ({
  adjustment,
  ...props
}) => {
  const {
    policy: {
      currentPolicyVersion: { quote },
    },
  } = usePolicy()
  const { product } = useProduct()

  const { coverLevelOption } = useCoverLevelOption(quote, product)

  switch (coverLevelOption?.paymentScheduleType) {
    case 'MONTHLY':
      return <MonthlyPremiumSection adjustment={adjustment} {...props} />
    case 'SINGLE_PAYMENT':
      return <SinglePaymentPremiumSection adjustment={adjustment} {...props} />
  }
}
